import { Reveal } from "@/components/Motion";

export default function SectionHeader({ overline, title, copy, dark = false, center = false, testid }) {
  return (
    <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      <p data-testid={testid ? `${testid}-overline` : undefined} className="overline text-gold-muted">
        {overline}
      </p>
      <h2
        className={`mt-4 font-serif text-3xl leading-[1.15] tracking-tight sm:text-4xl ${
          dark ? "text-white" : "text-obsidian"
        }`}
      >
        {title}
      </h2>
      {copy && (
        <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-slate-400" : "text-slate-600"}`}>
          {copy}
        </p>
      )}
    </Reveal>
  );
}
